import React from 'react';
import { Badge, Tooltip, OverlayTrigger } from 'react-bootstrap';

export const GROUP_ACK_COLOR = 'rgb(25, 135, 133)';
export const USER_ACK_COLOR = 'rgb(25, 135, 84)';

const AlertBadge = ({alert, placement="left"}) => (
    <OverlayTrigger
        placement={placement}
        overlay={
            <Tooltip>
                <strong>Alert Levels:</strong><br/>
                <strong style={{ color: '#0dcaf0' }}>Info:</strong> RSO is <u>not</u> ranked<br/>
                <strong style={{ color: '#ffc107' }}>Warning:</strong> RSO is ranked<br/>
                <strong style={{ color: '#dc3545' }}>Danger:</strong> RSO is ranked, and has dangerous RPO&apos;s
            </Tooltip>
        }
    >
        <Badge
            bg={alert.Level?.toLowerCase() || 'info'}
            className={alert.Level?.toLowerCase() === 'warning' ? 'text-dark' : ''}
            style={{ cursor: 'help' }}>
            {(alert.Level ?? 'INFO').toUpperCase()}
        </Badge>
    </OverlayTrigger>
);

export default AlertBadge; 